class AlertaServiceService
  @$inject = ['genericServiceHelper', 'httpService']

  constructor: (serviceHelper, @httpService) ->
    @url = '/eficiencia-fiscal/alerta/'

    serviceHelper(
      url: @url
      screenId: '#eficiencia-fiscal'
      service: this
    )

  getAlertas: (callback) ->
    @httpService.request({
      url: '/api' + @url,
      method: "PUT",
      data: {"function": "buscar_alertas"},
      blockScreen: true,
      screenId: '#eficiencia-fiscal',
      onSuccess: (data) ->
        callback(data);
    })

angular.module('eficienciaFiscalModule').service('alertaService', AlertaServiceService)
